import React from "react";
import useIsActive from "src/hooks/useIsActive";
import useIsHovered from "src/hooks/useIsHovered";
import CircularProgress from "src/components/CircularProgress";
import { Activities } from "src/modules/activity-log/activity";
import icons from "src/modules/command/commands-icons";
import colors from "src/modules/command/colors";
import RoundButton from "../../RoundButton";
import { ReactComponent as CloseIcon } from "./close.svg";

export default function RoundButtonWithProgress({
  status,
  onClick,
  color,
  icon,
  isDarkMode,
  activity,
  mode,
  getProgress,
  onFinish
}) {
  const hasShadow = isDarkMode === false && status !== "resting";

  const [htmlElement, setHtmlElement] = React.useState();
  const isHovered = useIsHovered(htmlElement);
  const isActive = useIsActive(htmlElement);

  return (
    <div ref={setHtmlElement}>
      <CircularProgress
        onClick={onClick}
        progressOnTop={true}
        status={status === "playing" ? "running" : "hidden"}
        getProgress={getProgress}
        onFinish={onFinish}
        progressTrail={false}
        borderWidth={4}
        size={["40px", "56px", "64px"]}
        color={color}
      >
        <RoundButton
          icon={status === "resting" ? icons[icon].icon : CloseIcon}
          iconFill={status === "resting" ? "white" : colors[color].name}
          iconSize="50%"
          size={["40px", "56px", "64px"]}
          bg={status === "resting" ? colors[color].name : "white"}
          forceHover={isHovered}
          forceActive={isActive}
          {...(activity === Activities.AWAKE &&
            mode === "audio" &&
            color === "command-tint1" && {
              border: "1px solid rgba(255,255,255,0.20)"
            })}
          boxShadow={
            hasShadow
              ? "0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)"
              : "none"
          }
        />
      </CircularProgress>
    </div>
  );
}
